var map = {
	"./Casino-1133.json": [
		97944,
		944
	],
	"./Casino-31337.json": [
		32645,
		645
	],
	"./Casino-address-1133.json": [
		2664,
		664
	],
	"./Casino-address-31337.json": [
		88558,
		558
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 64602;
module.exports = webpackAsyncContext;